import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import toFinite from 'lodash/toFinite'
import find from 'lodash/find'

import { CryptoPaymentWithdrawalFromContent } from './CryptoPaymentWithdrawalFormContent'
import l10n from '../../i18n/I18N'
import { getCurrencyConfigForWalletId, getRedeemablePlayerWallets, tokenizer } from '../../../services/utils'
import { config } from '../../Init/Init'
import { usePlayerStore } from '../../../services/store'
import { useCryptoPaymentDataModal } from '../CryptoPaymentModalDataProvider'
import { withdrawFormFields } from '../cryptoPaymentConstants'

export const CryptoPaymentWithdrawalForm = () => {
  const playerStore = usePlayerStore()
  const playerWallets = playerStore.use.playerWallets()

  const { handleSubmit, selectedCurrency, isXRPCryptoType } = useCryptoPaymentDataModal()

  const currencyConfig = getCurrencyConfigForWalletId(playerWallets, config.cryptoRedeemableWalletIds[0])

  const doesWalletContainEnough = value => {
    if (value) {
      const validWallets = getRedeemablePlayerWallets(playerWallets)

      return value && toFinite(value) < find(validWallets, { currencyId: currencyConfig.currencyId }).amount
    }
    return false
  }

  const initialValues = {
    [withdrawFormFields.currency]: selectedCurrency.currencyCode,
    [withdrawFormFields.destinationTag]: '',
    [withdrawFormFields.amountInTargetCurrency]: '',
    [withdrawFormFields.protocol]: null,
    [withdrawFormFields.targetCurrency]: '',
    [withdrawFormFields.address]: '',
    [withdrawFormFields.cryptoAmount]: ''
  }

  const validationSchema = Yup.object().shape({
    [withdrawFormFields.currency]: Yup.string().required(l10n.t['validation.required']),
    [withdrawFormFields.destinationTag]: Yup.string().test('destination_tag', l10n.t['validation.required'], value => {
      if (isXRPCryptoType && !value) {
        return false
      }
      return true
    }),
    protocol: Yup.string().when('currency', {
      is: () => selectedCurrency.protocols.length !== 0,
      then: Yup.string().required(l10n.t['validation.required']),
      otherwise: Yup.string().nullable()
    }),
    [withdrawFormFields.amountInTargetCurrency]: Yup.string()
      .required(l10n.t['validation.required'])
      .test(
        'min_withdrawal_amount',
        tokenizer(l10n.t['cryptopayment.validation.minwithdrawal'], {
          '{withdrawalCurrency}': currencyConfig.currencyName,
          '{minWithdrawalAmount}': config.cryptoWithdrawalMinUSD
        }),
        value => {
          const numberValue = Number(value?.replace(/,/g, ''))

          return numberValue >= config.cryptoWithdrawalMinUSD
        }
      )
      .test('bad_withdrawal_amount', l10n.t['validation.badAmount'], value => {
        const numberValue = Number(value?.replace(/,/g, ''))

        return doesWalletContainEnough(numberValue)
      }),
    [withdrawFormFields.address]: Yup.string().required(l10n.t['validation.required'])
  })

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
      <Form>
        <CryptoPaymentWithdrawalFromContent />
      </Form>
    </Formik>
  )
}
